export default __webpack_public_path__ + "static/media/reveal.d11fad94.mp4";